import styled, { keyframes } from "styled-components";
import { colors } from "../../../styles/colors";

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const StyledContactsSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  width: 100%;
  padding: 0 20px;
`;

export const StyledSkeletonItem = styled.div`
  border-bottom: 0.5px solid ${colors.lightBlueGray};
  padding-bottom: 17px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .skeleton-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-left: 15px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200px 100%;
    animation: ${shimmer} 1.5s infinite;
  }

  .skeleton-content {
    .skeleton-name {
      width: 120px;
      height: 16px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200px 100%;
      animation: ${shimmer} 1.5s infinite;
      border-radius: 4px;
      margin-bottom: 8px;
    }

    .skeleton-phone {
      width: 100px;
      height: 12px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200px 100%;
      animation: ${shimmer} 1.5s infinite;
      border-radius: 4px;
    }
  }

  .skeleton-date {
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .skeleton-source {
      width: 80px;
      height: 14px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200px 100%;
      animation: ${shimmer} 1.5s infinite;
      border-radius: 100px;
      margin-bottom: 8px;
    }

    .skeleton-join-date {
      width: 60px;
      height: 12px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200px 100%;
      animation: ${shimmer} 1.5s infinite;
      border-radius: 4px;
    }
  }
`;
